import React, { useState } from 'react';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Filter } from 'lucide-react';

interface ComplianceItem {
  id: string;
  document: string;
  status: 'Valid' | 'Expiring Soon' | 'Expired';
  expiresOn: string;
}

const mockCompliance: ComplianceItem[] = [
  { id: 'INS001', document: 'Trucking Insurance', status: 'Valid', expiresOn: '2025-12-31' },
  { id: 'AUTH001', document: 'FMCSA Authority', status: 'Valid', expiresOn: '2026-03-15' },
  { id: 'PERMIT-TX', document: 'Oversize Permit (TX)', status: 'Expiring Soon', expiresOn: '2025-08-10' },
  { id: 'DOT-TRK', document: 'DOT Inspection (Truck)', status: 'Expired', expiresOn: '2024-11-02' },
  { id: 'MED-DR', document: 'Driver Medical Cert.', status: 'Valid', expiresOn: '2025-05-22' },
];

const statusVariant = {
  Valid: 'default',
  'Expiring Soon': 'warning',
  Expired: 'destructive',
};

export default function ComplianceTab() {
  const [search, setSearch] = useState('');
  const filtered = mockCompliance.filter(item =>
    item.document.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <Input
          placeholder="Search documents..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="max-w-sm"
        />
        <Button variant="outline" size="sm">
          <Filter className="mr-2 h-4 w-4" /> Filter
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Document</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Expires On</TableHead>
            <TableHead>Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filtered.map(item => (
            <TableRow key={item.id} className="hover:bg-gray-50">
              <TableCell className="font-medium">{item.document}</TableCell>
              <TableCell>
                <Badge variant={statusVariant[item.status] as any}>
                  {item.status}
                </Badge>
              </TableCell>
              <TableCell>{item.expiresOn}</TableCell>
              <TableCell>
                {item.status === 'Expiring Soon' || item.status === 'Expired' ? (
                  <Button size="sm">Renew</Button>
                ) : (
                  <Button size="sm" variant="outline">
                    View
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}